export default __webpack_public_path__ + "static/media/station-login.61dff6aa.png";